export const REQEST_ACTIVITY_GRID_COLUMN = {
    ID: "Id",
    BUYMANAGER:"BuyManager",
    HIDE_EVENT: "HideEvent",
    EVENT_INFO: "EventInfo",
    EVENT: "Event",
    VENUE: "Venue",
    EVENT_DATE: "EventDate",
    SALE_DATE: "SaleDate",
    PURCHASED: "Purchased",
    PASSED: "Passed",
    LOST: "Lost",
    PENDING: "Pending"
}